import imageCompression from 'browser-image-compression';

const COMPRESSION_OPTIONS = {
  alwaysKeepResolution: true,
  maxSizeMB: 1,
  useWebWorker: true,
  // Skip library EXIF parsing: getExifOrientation() can throw an uncaught
  // RangeError on JPEGs with malformed/empty EXIF blocks (see utils.js:364).
  // Modern browsers auto-orient images when drawing to canvas anyway.
  exifOrientation: 1,
} as const;

/** Worker-created Blobs can fail instanceof checks and break native drag-and-drop. */
export const toMainThreadFile = (blob: Blob, source: File): File => {
  if (blob === source) return source;
  return new File([blob], source.name, {
    type: blob.type || source.type,
    lastModified: Date.now(),
  });
};

export const compressImageForUpload = async (
  imageFile: File,
): Promise<File> => {
  try {
    const compressed = await imageCompression(imageFile, COMPRESSION_OPTIONS);
    return toMainThreadFile(compressed, imageFile);
  } catch {
    // HEIC, very large images, or unsupported formats: keep the original so
    // the slot stays a valid Blob and drag-to-reorder keeps working.
    return imageFile;
  }
};
